import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import AppLogger from 'utils/AppLogger';

export const SYSTEM_LIMITS = {
	WAREHOUSE: 'warehouseLimit',
	SALES_CHANNEL: 'salesChannelLimit',
	SHIPPING_PARTNER: 'shippingPartnerLimit',
	BRAND: 'brandLimit',
	CUSTOMIZABLE_PAGE: 'customizablePageLimit'
};

const RestrictionData = {
	FreePackage: {
		[SYSTEM_LIMITS.SALES_CHANNEL]: 1,
		[SYSTEM_LIMITS.SHIPPING_PARTNER]: 1,
		[SYSTEM_LIMITS.CUSTOMIZABLE_PAGE]: 1
	},
	StarterPackage: {
		[SYSTEM_LIMITS.SALES_CHANNEL]: 3,
		[SYSTEM_LIMITS.SHIPPING_PARTNER]: 3,
		[SYSTEM_LIMITS.BRAND]: 3
	},
	ScalePackage: {},
	EnterprisePackage: {}
};

const useRestriction = () => {
	const planName = useSelector((state) => state.user.planName);

	const isRestricted = useCallback(
		(limitName, limitedValue) => {
			if (limitName === undefined || limitName === null) return false;

			let isRestricted = false;
			const data = RestrictionData[planName];

			if (data !== undefined) {
				const limit = data[limitName];

				if (limit !== undefined) {
					isRestricted = limit <= limitedValue;
				}
			} else {
				isRestricted = true;
				AppLogger.error(`Plan name ${planName} is not defined in RestrictionData`);
			}

			return isRestricted;
		},
		[planName]
	);

	return isRestricted;
};

export default useRestriction;
